import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20Korean%20manhwa%20style%20illustration%20of%20a%20cozy%20reading%20nook%20with%20warm%20ambient%20lighting%20and%20floating%20comic%20pages%20in%20the%20air%2C%20soft%20golden%20and%20cream%20tones%2C%20dreamy%20atmosphere%2C%20bookshelves%20with%20colorful%20comic%20books%2C%20gentle%20bokeh%20effect%2C%20Korean%20aesthetic%2C%20warm%20and%20inviting%20mood%2C%20artistic%20composition&width=1600&height=900&seq=hero-bg-hanmanwu&orientation=landscape"
          alt="韩漫屋 - 韩国漫画推荐平台"
          title="韩漫屋 - 韩国漫画推荐"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 mb-4 md:mb-6 leading-tight">
            发现你的下一部
            <br />
            <span className="text-primary-400">韩国漫画</span>挚爱
          </h1>
          <p className="text-sm md:text-lg text-background-200 max-w-xl mx-auto mb-8 md:mb-10 leading-relaxed">
            精心筛选的高质量韩国漫画推荐，浪漫、动作、奇幻、悬疑……
            <br className="hidden sm:block" />
            资源新颖，画质优良，让每一次阅读都成为享受
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/romance"
              className="px-8 py-3 rounded-lg bg-primary-500 text-background-50 dark:text-foreground-950 font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer no-underline"
            >
              开始探索
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-lg bg-background-50/20 text-background-50 backdrop-blur-sm font-medium text-sm hover:bg-background-50/30 transition-all whitespace-nowrap cursor-pointer no-underline border border-background-50/30"
            >
              了解更多
            </Link>
          </div>

          <div className="mt-8 md:mt-12 flex items-center justify-center gap-6 md:gap-10">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50 font-heading">200+</p>
              <p className="text-xs md:text-sm text-background-300 mt-1">精选漫画</p>
            </div>
            <div className="w-px h-8 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50 font-heading">50万+</p>
              <p className="text-xs md:text-sm text-background-300 mt-1">月活读者</p>
            </div>
            <div className="w-px h-8 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50 font-heading">4.7</p>
              <p className="text-xs md:text-sm text-background-300 mt-1">平均评分</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/70 text-2xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;